// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"7ba6c4e8","453":"e6b06965","548":"f0f5824a"}[chunkId] + ".chunk.js";
};